/**
 * element_viewed collector'i (opsiyonel).
 * Musteri sayfada data-supsis-view="fiyat-tablosu" isaretlemesi yapar,
 * element gorunur alana girince event uretilir. "Fiyat tablosunu gordu mu" sorusu.
 */
import { AUTO_EVENTS } from "../events";

const VIEW_ATTR = "data-supsis-view";
const VISIBLE_RATIO = 0.5;
const VISIBLE_DURATION_MS = 1000;

class ElementViewCollector {
    constructor(tracker) {
        this.tracker = tracker;
        this.observer = null;
        this.seen = [];
        this.timers = {};
    }

    start() {
        if (!window.IntersectionObserver) return;
        const self = this;

        this.observer = new IntersectionObserver(
            function (entries) {
                for (let i = 0; i < entries.length; i++) self.handleEntry(entries[i]);
            },
            { threshold: [VISIBLE_RATIO] }
        );

        this.observeAll();
        this.observeNewNodes();
    }

    observeAll() {
        const nodes = document.querySelectorAll("[" + VIEW_ATTR + "]");
        for (let i = 0; i < nodes.length; i++) this.observer.observe(nodes[i]);
    }

    observeNewNodes() {
        if (!window.MutationObserver || !document.body) return;
        const self = this;
        new MutationObserver(function (mutations) {
            for (let i = 0; i < mutations.length; i++) {
                const added = mutations[i].addedNodes || [];
                for (let j = 0; j < added.length; j++) {
                    const node = added[j];
                    if (!node || node.nodeType !== 1) continue;
                    if (node.hasAttribute && node.hasAttribute(VIEW_ATTR)) self.observer.observe(node);
                    if (node.querySelectorAll) {
                        const inner = node.querySelectorAll("[" + VIEW_ATTR + "]");
                        for (let k = 0; k < inner.length; k++) self.observer.observe(inner[k]);
                    }
                }
            }
        }).observe(document.body, { childList: true, subtree: true });
    }

    /** Kisa temaslar sayilmaz; element 1 sn gorunur kalmalidir. */
    handleEntry(entry) {
        const name = entry.target.getAttribute(VIEW_ATTR);
        if (!name) return;
        const self = this;

        if (!entry.isIntersecting || entry.intersectionRatio < VISIBLE_RATIO) {
            if (this.timers[name]) {
                clearTimeout(this.timers[name]);
                delete this.timers[name];
            }
            return;
        }

        if (this.seen.indexOf(name) !== -1 || this.timers[name]) return;

        this.timers[name] = setTimeout(function () {
            delete self.timers[name];
            if (self.seen.indexOf(name) !== -1) return;
            self.seen.push(name);
            self.tracker.emit(AUTO_EVENTS.ELEMENT_VIEWED, {
                element_name: String(name).slice(0, 120),
            });
            self.observer.unobserve(entry.target);
        }, VISIBLE_DURATION_MS);
    }
}

export default ElementViewCollector;



//////////////////
// WEBPACK FOOTER
// ./static/src/tracker/collectors/elementView.js
// module id = null
// module chunks = 